module.exports = __webpack_public_path__ + "img/logo__pixnet.d29a65c.svg";